<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" :modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="项目名称：" prop="project_id">
                <el-select v-model="model.project_id" clearable placeholder="请选择项目">
                    <el-option v-for="item in projectList" :key="'pl'+item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getProjectList } from '@/api/org'

export default {
    name: 'projectGroupItemEdit',
    mixins: [editutil],
    props: {
        group_id: {
            type: Number,
            default() {
                return -1;
            }
        },
    },
    data() {
        return {
            model: {
                group_id: '',
                group_name: '',
                project_id: '',
                project_name: '',
                order_index: '',
            },
            getObj:{
                url:'/api/admin/projectgroupitem/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                project_id: [
                    {required: true, message: '请选择项目', trigger: 'blur'}
                ],
            },
            projectList: [],
        };
    },
    methods: {
        loadOtherData() {
            //加载其他内容， 可重写
            getProjectList().then(res=>{
                if(res.code ==1){
                    this.projectList = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/projectgroupitem/save'
                    }
                    this.model.group_id = this.group_id
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>